module.exports = __webpack_public_path__ + "static/media/Minos.00225cd9.jpg";